import { render, staticRenderFns } from "./SectionLinkWidget.vue?vue&type=template&id=f0c42b6e&"
import script from "./SectionLinkWidget.vue?vue&type=script&lang=ts&"
export * from "./SectionLinkWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports